import { Button, Input, Modal, Popconfirm, Space, Tag, message } from "antd";
import AlarmContactApi from "../../api/AlarmContactApi";
import { useEffect, useState } from "react";
import Table, { ColumnType } from "antd/es/table";
import StringUtils from "../../util/StringUtils";
import { AlarmContactManagementWrapper, TableWrapper, ToolBarLeftWrapper, ToolBarRightWrapper, ToolBarWrapper } from "./AlarmContactManagement.styled";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import CreateAlarmContact from "./create-contact-management/CreateAlarmContact";
import PermissionWrapper from "../../components/permission/PermissionWrapper";

interface AlarmContactManagementProps {

}

const AlarmContactManagement: React.FC<AlarmContactManagementProps> = (props)=> {
    // api
    let alarmContactApi = new AlarmContactApi();
    const [messageApi, contextHolder] = message.useMessage();

    // state
    let [loading, setLoading] = useState(true);
    let [alarmContactViews, setAlarmContactViews] = useState([]);
    let [openCreateAlarmContactModal, setOpenCreateAlarmContactModal] = useState(false);
    let [editingAlarmContactId, setEditingAlarmContactId] = useState(null);
    let [searchValue, setSearchValue] = useState("");

    // events
    let onEditAlarmContactDetails = (alarmContactView: any)=> {
        setEditingAlarmContactId(alarmContactView.id);
        setOpenCreateAlarmContactModal(true);
    };

    let onAddAlarmContactClick = ()=> {
        setEditingAlarmContactId(null);
        setOpenCreateAlarmContactModal(true);
    };

    let onDeleteAlarmContact = async (alarmContactView: any)=> {
        await alarmContactApi.delete(alarmContactView.id);
        messageApi.open({
            type: 'success',
            content: '删除告警联系人成功',
        });
        loadAlarmContactViews();
    };

    let onInputChange = (e)=> {
        setSearchValue(e.target.value);
    };

    // load alarm contact views
    let loadAlarmContactViews = async ()=> {
        setLoading(true);
        let alarmContactViews = (await alarmContactApi.getAll()).data.data;
        setAlarmContactViews(alarmContactViews);
        setLoading(false);
    }

    // column definition
    let columns: ColumnType<any>[] = [
        {
            title: '姓名',
            dataIndex: 'name',
            key: 'name',
            align: 'center',
            render: (text, record, index)=> {
                return <a onClick={()=> onEditAlarmContactDetails(record)}>{record.name}</a>
            }
        },
        {
            title: '短信',
            dataIndex: 'phone',
            key: 'phone',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{StringUtils.emptyToSlash(record.phone)}</span>
            }
        },
        {
            title: '邮箱',
            dataIndex: 'email',
            key: 'email',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{StringUtils.emptyToSlash(record.email)}</span>
            }
        },
        {
            title: '备注',
            dataIndex: 'remarks',
            key: 'remarks',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{StringUtils.emptyToSlash(record.remarks)}</span>
            }
        },
        {
            title: '操作',
            key: 'action',
            align: 'center',
            render: (text, record, index)=> {
                return <Space size="middle">
                    <PermissionWrapper permissionCodePath="alarm-management.alarm-contacts.update-alarm-contact">
                        <a onClick={()=> onEditAlarmContactDetails(record)}>编辑联系人</a>
                    </PermissionWrapper>

                    <PermissionWrapper permissionCodePath="alarm-management.alarm-contacts.delete-alarm-contact">
                        <Popconfirm
                                title="删除告警联系人"
                                description={ <div style={{paddingTop: "10px", paddingBottom: '10px'}}>确认要删除告警联系人么?</div> }
                                onConfirm={()=> onDeleteAlarmContact(record)}
                                okText="确定"
                                cancelText="取消"
                            >
                            <a>删除联系人</a>
                        </Popconfirm>
                    </PermissionWrapper>
                </Space>
            }
        }
    ];

    let filteredAlarmContactViews = [].concat(alarmContactViews);
    if (searchValue) {
        filteredAlarmContactViews = filteredAlarmContactViews.filter((e)=> {
            let name = e.alarmContact.name || '';
            let phone = e.alarmContact.phone || '';
            let email = e.alarmContact.email || '';
            if (name.indexOf(searchValue)>=0
            || phone.indexOf(searchValue)>=0
            || email.indexOf(searchValue)>=0) {
                return true;
            }
            return false;
        });
    }

    // effect
    useEffect(()=> {
        loadAlarmContactViews();
    }, []);

    // render
    return (
        <AlarmContactManagementWrapper>
            {contextHolder}
            <ToolBarWrapper>
                <ToolBarLeftWrapper>
                    <Space size="middle">
                        <PermissionWrapper permissionCodePath="alarm-management.alarm-contacts.create-alarm-contact">
                            <Button type="primary" icon={<PlusOutlined />} onClick={onAddAlarmContactClick}>创建联系人</Button>
                        </PermissionWrapper>
                    </Space>
                </ToolBarLeftWrapper>

                <ToolBarRightWrapper>
                    <Input
                        placeholder="请输入姓名/短信/邮箱"
                        suffix={<SearchOutlined />}
                        size="middle"
                        onChange={onInputChange} />
                </ToolBarRightWrapper>

                <Modal open={openCreateAlarmContactModal}
                    onClose={()=> setOpenCreateAlarmContactModal(false)}
                    destroyOnClose={true}
                    footer={null}
                    closable={false}
                    width={700}
                    height={500}
                    >
                    <CreateAlarmContact
                        alarmContactId={editingAlarmContactId}
                        onClose={()=> setOpenCreateAlarmContactModal(false)}
                        onComplete={()=> {
                            setOpenCreateAlarmContactModal(false);
                            loadAlarmContactViews();
                        }}/>
                </Modal>
            </ToolBarWrapper>
            <TableWrapper>
                <Table
                    rowKey={(record)=> record.id}
                    columns={columns}
                    dataSource={filteredAlarmContactViews}
                    loading={loading}
                />
            </TableWrapper>
        </AlarmContactManagementWrapper>
    );
}

export default AlarmContactManagement;
